import type { ChartConfig } from '@chartforge/shared-types';

/**
 * Tiny typed accessors over ChartConfig buckets. Charts read configuration
 * exclusively through these helpers — never through scattered conditionals.
 */
export function str(
  config: ChartConfig,
  group: keyof ChartConfig,
  id: string,
  fallback: string
): string {
  const value = config[group]?.[id];
  return typeof value === 'string' ? value : fallback;
}

export function num(
  config: ChartConfig,
  group: keyof ChartConfig,
  id: string,
  fallback: number
): number {
  const value = config[group]?.[id];
  return typeof value === 'number' && Number.isFinite(value) ? value : fallback;
}

export function bool(
  config: ChartConfig,
  group: keyof ChartConfig,
  id: string,
  fallback: boolean
): boolean {
  const value = config[group]?.[id];
  return typeof value === 'boolean' ? value : fallback;
}
